<template>
  <div class="calendar-history">
    <div v-for="(item, i) in items" :key="item.shop_date" class="history-item">
      <div v-if="isDateVisible(items[i - 1], item)" class="history-item__date">
        {{ $getFormattedDate(item.shop_date, "DD MMMM") }}
      </div>
      <div class="history-item__card">
        <div class="card__logo">
          <img
            v-if="item.oper_code === 'FINE_OVERDUE'"
            src="@/assets/images/warning_grey.png"
          />
          <img
            v-else-if="item.oper_code === 'CLUB_FEE'"
            src="@/assets/images/red_icon_rounded.png"
          />
          <div
            v-else-if="item.oper_code === 'PURCHASE_SHOP'"
            class="i-shop-logo"
          ></div>
          <img
            v-else
            :src="`${cdnUrl}${item.merchant_id}.png`"
            @error="setAltImg($event, item.merchant_location)"
          />
        </div>
        <div class="card__content">
          <div class="card__content_primary">
            <div class="card__title">
              <template v-if="item.oper_code === 'FINE_OVERDUE'">
                {{ $t`Штраф` }}
              </template>
              <template v-else-if="item.oper_code === 'CLUB_FEE'">
                {{ $t`Клубный взнос` }}
              </template>
              <template v-else>
                {{ item.merchant_location }}
              </template>
            </div>
            <div class="card__amount">
              <div class="card__amount_overall">
                <template v-if="item.oper_code === 'CLUB_FEE'">
                  {{ $currencyFormatter(clubFee) }}
                </template>
                <div
                  v-else-if="item.status === 'PAID'"
                  class="card__amount_overall--paid"
                >
                  {{ $t`Оплачено` }}
                </div>
                <template v-else>
                  {{ $currencyFormatter(item.payment_plan_sum) }}
                </template>
              </div>
            </div>
          </div>
          <div
            v-if="
              item.oper_code === 'PURCHASE' ||
              item.oper_code === 'PURCHASE_SHOP' ||
              item.oper_code === 'HOLD_PURCHASE' ||
              item.oper_code === 'HOLD_DELIV' || item.oper_code === 'HOLD_PURCHASE_SHOP'
            "
            class="card__content_secondary"
          >
            <div
              class="card__title card__title--hold"
              v-if="item.oper_code === 'HOLD_PURCHASE' || item.oper_code === 'HOLD_DELIV' || item.oper_code === 'HOLD_PURCHASE_SHOP'"
            >
              <div :class="isHoldTypeIcon"></div>
              <div
                :style="{
                  padding: `0 0 0 4px`,
                }"
              >
                {{ $t`Покупка на` }} {{ $currencyFormatter(item.shop_sum) }}
              </div>
            </div>
            <div v-else class="card__title card__title--hint">
              {{ $t`Покупка на` }} {{ $currencyFormatter(item.shop_sum) }}
            </div>
            <div class="card__amount--hint card__amount--hint">
              <template v-if="$cookie.getCookie('locale') === 'kk-KZ'">
                {{ item.payments_count }} {{ $t`платеж из` }}
                {{ kazOrderNumbers[item.payment_number - 1] }}
              </template>
              <template v-else>
                {{ item.payment_number }} {{ $t`платеж из` }}
                {{ item.payments_count }}
              </template>
            </div>
          </div>
        </div>
      </div>
      <Divider v-if="i !== items.length - 1" />
    </div>
  </div>
</template>

<script>
import Divider from "@/components/shared/divider/Divider.vue";

export default {
  components: { Divider },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      cdnUrl: "https://static.cdn-kaspi.kz/kkz/bank/icons/bymerchantid/",
      kazOrderNumbers: [this.$t`первый`, this.$t`второй`, this.$t`третий`],
      clubFee: 3995,
    };
  },
  computed: {
    isHoldTypeIcon() {
      return"i-hold-timer"
    },
  },
  methods: {
    setAltImg(e, name) {
      const logoContainer = e.target.parentNode;
      logoContainer.classList.add("card__logo--custom");
      if (name) {
        logoContainer.setAttribute("data-logo", name[0]);
      }
    },
    isDateVisible(item1, item2) {
      if (!item1 || !item2) {
        return true;
      }
      return (
        item1.shop_date.substring(0, 10) !== item2.shop_date.substring(0, 10)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

$logo-diameter: 38px;

.divider {
  padding: 0 15px;
}

.history-item {
  margin-bottom: 1px;
  text-align: left;

  &__date {
    padding: 10px 0 7px 13px;
    font-size: 12px;
    line-height: 14px;
    color: $colorWarmGrey;
    text-transform: uppercase;
  }

  &__card {
    display: flex;
    padding: 16px 15px;
    align-items: center;
    background-color: white;

    .card {
      &__logo {
        text-align: center;
        min-width: $logo-diameter;
        max-width: $logo-diameter;
        height: $logo-diameter;

        & > img {
          width: 100%;
          height: 100%;
        }

        &--custom {
          position: relative;
          min-width: $logo-diameter;
          min-height: $logo-diameter;
          background-color: $colorRed;
          border-radius: 50%;
          overflow: hidden;

          & > img {
            display: none;
          }

          &::before {
            content: attr(data-logo);
            position: absolute;
            left: 50%;
            line-height: $logo-diameter;
            transform: translate(-50%);
            font-size: 22px;
            color: white;
          }
        }
      }

      &__hint {
        margin-top: 5px;
        font-size: 12px;
        line-height: 14px;
        color: #a8a8a8;
      }

      &__content {
        flex: 1;
        width: calc(80%);
        padding-left: 15px;

        &_primary,
        &_secondary {
          display: flex;
          max-width: inherit;
          align-items: center;
          color: $colorTextMain;
          justify-content: space-between;
        }
      }

      &__title {
        margin-bottom: 2px;
        margin-right: 10px;
        width: calc(100%);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &--hint {
          font-size: 12px;
          line-height: 14px;
          color: #a8a8a8;
          text-align: left;
        }
        &--hold {
          font-size: 12px;
          line-height: 14px;
          color: #a8a8a8;
          text-align: left;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }

      &__amount {
        flex: 1;
        width: min-content;
        color: inherit;
        white-space: nowrap;
        text-align: right;
        padding: 0;

        &--hint {
          width: 100%;
          font-size: 12px;
          line-height: 14px;
          color: #a8a8a8;
          text-align: right;
        }

        &_overall {
          &--paid {
            margin-bottom: 2px;
            font-size: 17px;
            line-height: 20px;
            color: $colorGreen;
          }
        }
      }
    }
  }
}
</style>
